module.exports = __webpack_public_path__ + "static/media/Fa.Hengel_Image2_2025.71c3ba3f.png";